import { createContext, useContext } from 'react';
export const WidgetResizeContext = /*#__PURE__*/createContext(null);
export const useWidgetResizeContext = () => useContext(WidgetResizeContext);